import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) {
      toast.success("Signed in.");
      navigate("/admin");
    } else {
      setError("Invalid email or password");
    }
  }

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-4 py-24">
      <div className="border border-white/10 bg-zinc-900/40 p-8 md:p-10">
        <LogIn size={28} className="text-orange-500 mb-4" />
        <h1 className="font-display text-3xl uppercase mb-2">Admin Login</h1>
        <p className="text-sm text-zinc-400 mb-6">KPMX workshop only.</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="font-mono text-xs uppercase tracking-widest text-zinc-400">Email</label>
            <input required type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-zinc-950 border border-white/10 focus:border-orange-500 focus:ring-2 focus:ring-orange-600/30 outline-none px-4 py-3 text-white" />
          </div>
          <div>
            <label className="font-mono text-xs uppercase tracking-widest text-zinc-400">Password</label>
            <input required type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-zinc-950 border border-white/10 focus:border-orange-500 focus:ring-2 focus:ring-orange-600/30 outline-none px-4 py-3 text-white" />
          </div>
          {error && <div data-testid="admin-login-error" className="text-sm text-red-400">{error}</div>}
          <button type="submit" disabled={submitting} data-testid="admin-login-btn"
            className="btn-hard w-full bg-orange-600 hover:bg-orange-500 text-white px-6 py-3 font-display uppercase tracking-widest text-sm disabled:opacity-50">
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
